module.exports = __webpack_public_path__ + "static/media/Cybertruck_BackgroundPic.5e553c2e.jpg";